import { Injectable, signal } from '@angular/core';
import { UNSUPPORTED_DEVICE_MEDIA_QUERY } from '../Consts/device-support.const';

@Injectable({ providedIn: 'root' })
export class DeviceSupportService {
  private readonly _blocked = signal(false);

  readonly blocked = this._blocked.asReadonly();

  constructor() {
    const query = window.matchMedia(UNSUPPORTED_DEVICE_MEDIA_QUERY);
    this._blocked.set(query.matches);
    query.addEventListener('change', (event) => this._blocked.set(event.matches));
  }
}
